export default "/images/productCategory_logo.jpeg?40b774756dfcc6539f1ec08e9d03b41d";